import { useContext, useEffect } from "react";
import { formattedPrice } from "../../../../../../../../shared/utils";
import { StepOneFormContext } from "../../../contexts/StepOneForm";
import { Checkbox, Tooltip } from 'antd';
import { DebtQuote } from "../../../../../shared/interfaces/services/get-debt-columns-service.interface";
import { getDebtQuoteKey } from "../../../../../shared/utils/debt-quote-checkbox";
import { DECISION_TYPE } from "../../../../../../../../shared/interfaces";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { MasterContext } from "../../../../../../../../shared/contexts";


export const useTableConfiguration = () => {

  const {
    checkboxList,
    preliquidationDataWithFilters,
    updateRowCheckboxState,
    updateColumnCheckboxStateForVisible,
  } = useContext(StepOneFormContext);

  const { branchList, getBranchsList } = useContext(MasterContext);
  
  useEffect(() => {
    if(!branchList?.length) getBranchsList();
  }, [branchList]);

  const getBranchName = (branchId:string) => {
    const branch = branchList?.find((b) => b.value === branchId);
    return branch ? branch.label : branchId;
  };

  const renderBranchColumn = (branchId:string) => getBranchName(branchId);

  //Renderizado de coulmnas de tipo checkbox
  const renderHeaderCheckbox = (colKey: string) => {

    // Chequeo si todos los checkboxes de una columna están seleccionados
    const isAllChecked = (column: string) => preliquidationDataWithFilters.length > 0 && preliquidationDataWithFilters.every((item: any) => item[column]);

    //Logica por cada checkbox individual
    const handleCheckboxChange = (recordKey: string, column: string, checked: boolean) => {
      updateRowCheckboxState(recordKey, column, checked);
    };

    const handleHeaderCheckboxChange = (column: string, checked: boolean) => {
      updateColumnCheckboxStateForVisible(column, checked);
    };

    return {
      title: (
        <Checkbox
          checked={isAllChecked(colKey)}
          onChange={(e) => handleHeaderCheckboxChange(colKey, e.target.checked)}
        >
          {/* Nothing... */}
        </Checkbox>
      ),
      dataIndex: colKey,
      key: colKey,
      width: 2,
      render: (value: boolean, record: DebtQuote) => (
        <Checkbox
          checked={value}
          disabled={(record as any)[colKey.substring(0, colKey.length - 3)] === '.00'}
          onChange={(e) =>
            handleCheckboxChange(getDebtQuoteKey(record), colKey, e.target.checked)
          }
        />
      ),
    };
  }

  //Renderizado de celdas de tipo moneda
  const renderCurrency = (value: string, record: DebtQuote) => {
    return `$ ${formattedPrice(value.toString())}`
  }

  const columns = [
    {
      title: 'Rama',
      dataIndex: 'rama',
      key: 'rama',
      render: renderBranchColumn,
      width: 120,
    },
    {
      title: 'Póliza',
      dataIndex: 'poliza',
      key: 'poliza',
      width: 80,
      render: (value: string, record: DebtQuote) => {
        //debitoAutomatico
        return (
          record.debitoAutomatico === DECISION_TYPE.YES ?
          <Tooltip placement="right" title={'Débito Automático'}>
            {record.poliza} <QuestionCircleOutlined />
          </Tooltip>
          :
          record.poliza
        )
      }
    },
    {
      title: 'Asegurado',
      dataIndex: 'asegurado',
      key: 'asegurado',
      width: 120,
    },
    {
      title: 'Endoso',
      dataIndex: 'suplementoSpol',
      key: 'suplementoSpol',
      width: 20,
    },
    renderHeaderCheckbox('deudaAnteriorOPT'),
    {
      title: 'Deuda Anterior',
      dataIndex: 'deudaAnterior',
      key: 'deudaAnterior',
      render: renderCurrency,
      width: 60,
    },
    renderHeaderCheckbox('quincenaAnteriorOPT'),
    {
      title: 'Quincena Anterior',
      dataIndex: 'quincenaAnterior',
      key: 'quincenaAnterior',
      render: renderCurrency,
      width: 80,
    },
    renderHeaderCheckbox('quincenaActualOPT'),
    {
      title: 'Quincena Actual',
      dataIndex: 'quincenaActual',
      key: 'quincenaActual',
      render: renderCurrency,
      width: 60,
    },
    renderHeaderCheckbox('quincenaSiguienteOPT'),
    {
      title: 'Quincena Siguiente',
      dataIndex: 'quincenaSiguiente',
      key: 'quincenaSiguiente',
      render: renderCurrency,
      width: 80,
    },
    renderHeaderCheckbox('quincenaPosteriorOPT'),
    {
      title: 'Quincena Posterior',
      dataIndex: 'quincenaPosterior',
      key: 'quincenaPosterior',
      render: renderCurrency,
      width: 80,
    },
    renderHeaderCheckbox('saldoOPT'),
    {
      title: 'Saldo',
      dataIndex: 'saldo',
      key: 'saldo',
      render: renderCurrency,
      width: 80,
    },
    renderHeaderCheckbox('pagoContadoOPT'),
    {
      title: 'Contado',
      dataIndex: 'pagoContado',
      key: 'pagoContado',
      render: renderCurrency,
      width: 80,
    },
  ];

  return { columns };
};